import { render, staticRenderFns } from "./RegionUpdate.vue?vue&type=template&id=02fc5b6c"
import script from "./RegionUpdate.vue?vue&type=script&lang=ts"
export * from "./RegionUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports